import { useEffect, useState } from 'react'
import { IconButton } from '~/components/primitives/Button'

type Theme = 'system' | 'dark' | 'light'
const STORAGE_KEY = 'voe.theme'
const NEXT: Record<Theme, Theme> = { system: 'dark', dark: 'light', light: 'system' }
const ICON: Record<Theme, string> = { system: '◐', dark: '●', light: '○' }

function read(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored === 'dark' || stored === 'light' ? stored : 'system'
  } catch {
    return 'system'
  }
}

/**
 * Three states, not two: "system" is a real preference and overwriting it the first time
 * somebody clicks is how a console ends up permanently light on a dark desktop.
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(read)

  useEffect(() => {
    const root = document.documentElement
    if (theme === 'system') root.removeAttribute('data-theme')
    else root.setAttribute('data-theme', theme)
    try {
      if (theme === 'system') localStorage.removeItem(STORAGE_KEY)
      else localStorage.setItem(STORAGE_KEY, theme)
    } catch {
      /* a browser that refuses storage still gets the theme, just not next time */
    }
  }, [theme])

  return (
    <IconButton
      label={`Theme: ${theme}. Switch to ${NEXT[theme]}`}
      onClick={() => setTheme(NEXT[theme])}
    >
      <span aria-hidden>{ICON[theme]}</span>
    </IconButton>
  )
}
